<div class="py-1"></div>
<div class="card">
  <h6 class="card-header" style="cursor: pointer" (click)="showNewAkaForm = !showNewAkaForm"><i class="fas" [ngClass]="{ 'fa-plus-circle': !showNewAkaForm, 'fa-minus-circle': showNewAkaForm }"></i>&nbsp;New AKA</h6>
  <div class="card-body" [hidden]="!showNewAkaForm" style="max-height: 340px; overflow-y: scroll">
    <app-aka-form [contactId]="contactId" (saved)="formSaved($event)"></app-aka-form>
  </div>
</div>
<div class="py-1"></div>
<div class="float-right">
  <button type="button" [disabled]="loadingAkas" (click)="loadAkas()" class="btn btn-outline-primary btn-sm">
    <i class="fas fa-redo fa-fw" [ngClass]="{ 'fa-spin': loadingAkas }"></i>
  </button>
</div>
<div class="clearfix"></div>
<div class="py-1"></div>
<table class="table table-sm">
  <tbody  [appNativeSortableJs]="akas" [sortableOptions]="sortableOptions">
    <tr *ngFor="let aka of akas; let i = index">
      <td *ngIf="!aka.editing">
        <div class="alias-sort-handle d-inline-block py-1 px-2" style="cursor: grab" title="Sort">
          <i class="fas fa-random"></i>
        </div>
        <div class="btn-group btn-group-sm">
          <button title="Edit" (click)="aka.editing = true" type="button" class="btn btn-outline-primary btn-sm">
            <i class="fas fa-pencil-alt"></i>
          </button>
          <button title="Delete" (click)="deleteAka(aka, i)" type="button" class="btn btn-outline-danger btn-sm">
            <i class="fas fa-trash"></i>
          </button>
        </div>
      </td>
      <td *ngIf="!aka.editing">
        {{ aka.name }}
      </td>
      <td *ngIf="!aka.editing">
        {{ aka.type_name }}
      </td>
      <td colspan="3" *ngIf="aka.editing">
        <h6 class="font-italic text-info">Editing Alias</h6>
        <app-aka-form [aka]="aka" (saved)="formSaved($event, aka)"></app-aka-form>
      </td>
    </tr>
  </tbody>
</table>
